import React from "react";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "radix-ui";
import { ExternalLinkIcon } from "lucide-react";

/**
 * Reusable Kubernetes Dashboard information tooltip
 * Can be used in both the launchable create flow and environment create flow
 */
export const KubernetesDashboardInfoTooltip: React.FC = () => {
  return (
    <Tooltip.Root delayDuration={0}>
      <Tooltip.Trigger asChild>
        <InformationCircleIcon className="h-5 w-5 text-highlight cursor-help" />
      </Tooltip.Trigger>
      <Tooltip.Portal>
        <Tooltip.Content className="w-96 z-50 animate-fade-in rounded-md bg-zinc-800 text-white text-sm p-6 shadow-md">
          <div>
            <p className="mb-3">
              The Kubernetes Dashboard is a web-based UI for managing and
              monitoring your Kubernetes cluster.
            </p>
            <p className="font-semibold mb-2">What you'll get:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>
                <strong>Visual interface</strong> - Manage pods, deployments,
                and services through a GUI
              </li>
              <li>
                <strong>Resource monitoring</strong> - View real-time cluster
                metrics and logs
              </li>
              <li>
                <strong>One-click deployment</strong> - Automatically installed
                and ready to use on port 8001
              </li>
            </ul>
            <p className="mt-3 text-sm text-gray-300">
              If you prefer using kubectl and the command line, you can skip
              this option.
            </p>
            <p className="mt-3 text-sm text-gray-300">
              Learn more about the Kubernetes dashboard{" "}
              <span className="flex flex-row items-center gap-1">
                <a
                  href="https://kubernetes.io/docs/tasks/access-application-cluster/web-ui-dashboard/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-highlight hover:text-highlightDarker"
                >
                  here
                </a>
                <ExternalLinkIcon className="w-3 h-3" />
              </span>
            </p>
          </div>
          <Tooltip.Arrow />
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  );
};
